import { Component } from '@angular/core';
import { GlobalSidenavService } from '../../../core/services/global-sidenav.service';

@Component({
  selector: 'ctv-sidenav-button',
  templateUrl: './sidenav-button.component.html',
  styleUrls: ['./sidenav-button.component.scss']
})
export class SidenavButtonComponent {
  constructor(public sideNavService: GlobalSidenavService) {}
}
